import React, { useEffect, useState } from 'react';
import { createIntl, createIntlCache, RawIntlProvider } from 'react-intl';
import PropTypes from 'prop-types';
import { inject } from './QAU.ContextProvider';

const getAvailableLocale = locale => {
  const { content: availableLocales } = document.querySelector('meta[name="qau:available-locales"]');
  return availableLocales.includes(locale) ? locale : 'en-US';
};

const createIntlLocaleData = locale => {
  const availableLocale = getAvailableLocale(locale);
  const messages = require(`../../intl/default/data.${availableLocale}.json`);
  return { locale, messages, onError: () => {} };
};

const LocalizationProvider = ({ locale, children }) => {
  const [l10n, setL10n] = useState(null);

  useEffect(() => {
    const localeData = createIntlLocaleData(locale);
    const intl = createIntl(localeData, createIntlCache());
    setL10n(intl);
  }, [locale]);

  return (
    l10n && (
      <RawIntlProvider value={l10n}>
        <>{children}</>
      </RawIntlProvider>
    )
  );
};

LocalizationProvider.propTypes = {
  locale: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export default inject('locale')(LocalizationProvider);
